import React from "react";
import Image from "next/image";
import classNames from "classnames";
// @mui/icons-material
// import  from "@mui/icons-material/";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import Muted from "components/Typography/Muted.js";

import commonStyles from "./HomeCommon.module.scss";
import sectionStyles from "./Section3Team.module.scss";

export default function SectionTeams({ ...rest }) {
  return (
    <div className="cd-section" {...rest}>
      {/* Team 5 START */}
      <div className={classNames(sectionStyles.team, sectionStyles.section)}>
        <Image
          layout="fill"
          objectFit="cover"
          src={"/img/home_image-sm.webp"}
          alt=".."
          className={sectionStyles.backgroundImage}
        />

        <div className={classNames(commonStyles.container, sectionStyles.content)}>
          <GridContainer>
            <GridItem
              xs={12}
              sm={8}
              md={8}
              className={classNames(
                commonStyles.mlAuto,
                commonStyles.mrAuto,
                commonStyles.textCenter
              )}
            >
              <h2 className={classNames(commonStyles.title, sectionStyles.titleLight)}>
                Meet some of our team
              </h2>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card profile plain className={commonStyles.card5}>
                <GridContainer>
                  <GridItem xs={12} sm={5} md={5}>
                    <CardHeader image plain>
                      <a href="/about/profile-scott-sunderland">
                        <Image
                          layout="responsive"
                          width={207}
                          height={215}
                          src="/img/faces/scott-profile-small.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  <GridItem xs={12} sm={7} md={7}>
                    <CardBody plain>
                      <h4 className={commonStyles.cardTitle}>Scott Sunderland</h4>
                      <Muted>
                        <h6 className={commonStyles.cardCategory}>
                          FOUNDER/LEAD CONSULTANT
                        </h6>
                      </Muted>
                      <p className={commonStyles.description}>
                        We{"'"}re in a pandemic... a pandemic of busy-ness! I
                        think people appreciate quality work more than ever!
                      </p>
                    </CardBody>
                    <CardFooter profile plain>
                      <a
                        href=" https://twitter.com/ScottSunderl4nd"
                        target="_blank"
                      >
                        <Button justIcon simple>
                          <i className="fab fa-twitter" />
                        </Button>
                      </a>
                      <a
                        href="https://www.linkedin.com/in/scott-sunderland-86780641/"
                        target="_blank"
                      >
                        <Button justIcon simple>
                          <i className="fab fa-linkedin" />
                        </Button>
                      </a>
                      <a href="https://github.com/guruscott" target="_blank">
                        <Button justIcon simple>
                          <i className="fab fa-github" />
                        </Button>
                      </a>
                    </CardFooter>
                  </GridItem>
                </GridContainer>
              </Card>
            </GridItem>
            
            <GridItem xs={12} sm={6} md={6}>
              <Card profile plain className={commonStyles.card5}>
                <GridContainer>
                  <GridItem xs={12} sm={5} md={5}>
                    <CardHeader image plain>
                      <a href="/about/profile-robert-dzudzar">
                        <Image
                          layout="responsive"
                          width={207}
                          height={215}
                          src="/img/faces/Robert-sq.webp"
                          alt="..."
                        />
                      </a>
                    </CardHeader>
                  </GridItem>
                  <GridItem xs={12} sm={7} md={7}>
                    <CardBody plain>
                      <h4 className={commonStyles.cardTitle}>Robert Dzudzar</h4>
                      <Muted>
                        <h6 className={commonStyles.cardCategory}>
                          Analytics Manager
                        </h6>
                      </Muted>
                      <p className={commonStyles.description}>
                        Data is like the Universe, vast and powerful.
                      </p>
                    </CardBody>
                    <CardFooter profile plain>
                      <a
                        href="https://au.linkedin.com/in/robertdzudzar"
                        target="_blank"
                      >
                        <Button justIcon simple>
                          <i className="fab fa-linkedin" />
                        </Button>
                      </a>
                      <a href="https://github.com/rdzudzar" target="_blank">
                        <Button justIcon simple>
                          <i className="fab fa-github" />
                        </Button>
                      </a>
                    </CardFooter>
                  </GridItem>
                </GridContainer>
              </Card>
            </GridItem>
            
          </GridContainer>
        </div>
      </div>
      {/* Team 5 END */}
    </div>
  );
}
